import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import type { IntentName } from "@/design";
import { Badge } from "@/shared/ui/badge";

import type { InboundDoc } from "../lib/inbound-filter";

const DIRECTION_INTENT: Record<InboundDoc["tran_type"], IntentName> = {
  IN: "success",
  OUT: "warning",
};

interface DirectionChipProps {
  direction: InboundDoc["tran_type"];
  testId?: string;
}

export function DirectionChip({ direction, testId }: DirectionChipProps): JSX.Element {
  const { t } = useTranslation("inbound_report");
  return (
    <Badge intent={DIRECTION_INTENT[direction]} data-testid={testId}>
      {t(`direction.${direction}`)}
    </Badge>
  );
}
